import React from 'react';
import Icon from '../../../components/AppIcon';

const AdminMetricCard = ({
  title = '',
  value = 0,
  trend = 'neutral',
  trendValue = 0,
  icon = 'Activity',
  color = 'blue',
  description = ''
}) => {
  const colorClasses = {
    blue: 'bg-blue-500/10 border-blue-500/20 text-blue-600',
    emerald: 'bg-emerald-500/10 border-emerald-500/20 text-emerald-600',
    violet: 'bg-violet-500/10 border-violet-500/20 text-violet-600',
    amber: 'bg-amber-500/10 border-amber-500/20 text-amber-600'
  };

  const iconColors = {
    blue: '#3B82F6',
    emerald: '#10B981',
    violet: '#8B5CF6',
    amber: '#F59E0B'
  };

  const getTrendIcon = () => {
    if (trend === 'up') return 'TrendingUp';
    if (trend === 'down') return 'TrendingDown';
    return 'Minus';
  };

  const getTrendColor = () => {
    if (trend === 'up') return 'text-emerald-600';
    if (trend === 'down') return 'text-red-600';
    return 'text-slate-500';
  };

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-6 elevation-sm hover:elevation-md transition-all">
      <div className="flex items-start justify-between mb-4">
        <div className={`w-12 h-12 rounded-lg border flex items-center justify-center ${colorClasses?.[color]}`}>
          <Icon name={icon} size={24} color={iconColors?.[color]} />
        </div>
        {trendValue !== 0 && (
          <div className={`flex items-center gap-1 ${getTrendColor()}`}>
            <Icon name={getTrendIcon()} size={16} />
            <span className="text-sm font-medium">
              {Math.abs(trendValue)}%
            </span>
          </div>
        )}
      </div>

      <div className="space-y-2">
        <p className="text-sm text-slate-600 font-medium">
          {title}
        </p>
        <p className="text-3xl font-bold text-slate-900 font-heading">
          {value}
        </p>
        <p className="text-xs text-slate-500">
          {description}
        </p>
      </div>
    </div>
  );
};

export default AdminMetricCard;